import configureSubscriptionsManager from './configure-subscriptions-manager';

export default {
  configureSubscriptionsManager,
};
